// extracted by mini-css-extract-plugin
export default {"main":"HarvestMath_main__sze50"};